import { z } from 'zod'

export const reorderDashboardPluginsSchema = z.object({
  plugins: z.array(
    z.object({
      id: z.string().guid(),
      order: z.number().int().min(0),
    })
  ),
})
export type ReorderDashboardPluginsDto = z.infer<typeof reorderDashboardPluginsSchema>
